// extracted by mini-css-extract-plugin
module.exports = {"propertyContainer":"styles_propertyContainer__Avjw6","noHotelsYetContainer":"styles_noHotelsYetContainer__kUTGT","slide-in":"styles_slide-in__Ga7Nz"};